var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { marginTop: _vm.marginTop + "px" } },
    [
      [
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "flex-end" } },
          [
            _vm.uploadType == "video"
              ? _c(
                  "video",
                  {
                    ref: "videoPlayer",
                    staticStyle: { width: "500px", height: "400px" },
                    attrs: { controls: "", muted: "" },
                    domProps: { muted: true },
                    on: { ended: _vm.onVideoEnded },
                  },
                  [
                    _c("source", {
                      attrs: { src: _vm.previewImg, type: "video/mp4" },
                    }),
                    _vm._v(" Your browser does not support the video tag. "),
                  ]
                )
              : _vm._e(),
            _c(
              "el-upload",
              {
                ref: "upload",
                staticClass: "upload-demo",
                attrs: {
                  action: _vm.actionUrl,
                  "on-change": _vm.handleChangeUpload,
                  "auto-upload": false,
                  "show-file-list": false,
                  disabled: _vm.disabled,
                },
                scopedSlots: _vm._u([
                  {
                    key: "tip",
                    fn: function () {
                      return [
                        _vm.tip
                          ? _c("div", { staticClass: "el-upload__tip" }, [
                              _vm._v(_vm._s(_vm.tip)),
                            ])
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm.previewImg && _vm.uploadType != "video"
                  ? _c(
                      "div",
                      {
                        staticClass: "image-upload-list-item",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _vm.disabled
                          ? _c("el-image", {
                              staticClass: "upload-image-size",
                              attrs: {
                                src: _vm.previewImg,
                                fit: "cover",
                                "preview-src-list": [_vm.previewImg],
                                lazy: "",
                              },
                            })
                          : _c("el-image", {
                              staticClass: "upload-image-size",
                              attrs: {
                                src: _vm.previewImg,
                                fit: "cover",
                                lazy: "",
                              },
                            }),
                        !_vm.disabled
                          ? _c(
                              "div",
                              { staticClass: "image-upload__item-actions" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "del",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.deleteFn()
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-delete" })]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "el-upload--picture-card ",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-plus avatar-uploader-icon",
                        }),
                      ]
                    ),
              ]
            ),
            _vm.uploadType == "gif" || _vm.uploadType == "video"
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "danger", plain: "" },
                    on: { click: _vm.clearVioeo },
                  },
                  [_vm._v("删除视频")]
                )
              : _vm._e(),
            _vm.uploadType == "gif" || _vm.uploadType == "video"
              ? _c("span", { staticClass: "tipUpload ml16" }, [
                  _vm._v("*由于上传格式不是jpg,png，所以裁剪功能不能使用"),
                ])
              : _vm._e(),
          ],
          1
        ),
      ],
      _c(
        "el-dialog",
        {
          staticClass: "crop-dialog",
          attrs: {
            title: "图片剪裁",
            visible: _vm.dialogVisible,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { padding: "0 20px" } }, [
            _c(
              "div",
              {
                style: {
                  textAlign: "center",
                  width:
                    _vm.cropperWidth != 0 ? _vm.cropperWidth + "px" : "auto",
                  height: _vm.cropperHeight + "px",
                },
              },
              [
                _c("VueCropper", {
                  ref: "cropper",
                  attrs: {
                    img: _vm.cropperImg,
                    "output-size": _vm.outputSize,
                    "output-type": _vm.outputType,
                    info: _vm.info,
                    full: _vm.full,
                    "can-move": _vm.canMove,
                    "can-move-box": _vm.canMoveBox,
                    original: _vm.original,
                    "auto-crop": _vm.autoCrop,
                    "can-scale": _vm.canScale,
                    fixed: _vm.fixed,
                    "fixed-number": _vm.fixedNumber,
                    "fixed-box": _vm.fixedBox,
                    "center-box": _vm.centerBox,
                    "info-true": _vm.infoTrue,
                    "auto-crop-width": _vm.autoCropWidth,
                    "auto-crop-height": _vm.autoCropHeight,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.actionButtonFlag
            ? _c(
                "div",
                { staticClass: "action-box" },
                [
                  _c(
                    "el-upload",
                    {
                      staticStyle: { "margin-right": "15px" },
                      attrs: {
                        action: "#",
                        "auto-upload": false,
                        "show-file-list": false,
                        "on-change": _vm.handleChangeUpload,
                      },
                    },
                    [
                      _c("el-button", { attrs: { type: "primary" } }, [
                        _vm._v("更换图片"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.clearImgHandle },
                    },
                    [_vm._v("清除图片")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.rotateLeftHandle },
                    },
                    [_vm._v("左旋转")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.rotateRightHandle },
                    },
                    [_vm._v("右旋转")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.changeScaleHandle(2)
                        },
                      },
                    },
                    [_vm._v("放大")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.changeScaleHandle(-2)
                        },
                      },
                    },
                    [_vm._v("缩小")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.fixed = !_vm.fixed
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.fixed ? "固定比例" : "自由比例"))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.finish },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "图片预览",
            visible: _vm.previewDialogVisible,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewImg },
          }),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.previewDialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }